export default __webpack_public_path__ + "static/project-harmony-mockup-a8a6030c013b34998a166b6d33b9a58b.png";